module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/get-iterator.js